export const ROUTE_ROLES = {
    1: 'admin',
    2: 'consultor',
    3: 'admin',
    4: 'coordenador',
    5: 'supervisor',
    6: 'assistente',
    7: 'demonstracao'
};
